import {FederatedPointerEvent} from '@pixi/events';
import {Container, useApp} from '@pixi/react';
import {ReactNode, useEffect} from 'react';


interface SceneProps {
    children: ReactNode;
    mouseMoveHandler?: (event: FederatedPointerEvent) =>void;
}

export function Scene({children, mouseMoveHandler}: SceneProps) {
    const app = useApp();

    useEffect(() => {
        app.render();
    }, []);

    return (
        <Container width={1920} height={1080} onmousemove={mouseMoveHandler} interactive>
            {children}
        </Container>
    );
}